const state = {
  isPC:true,//是否是PC
  activePath:'/',
  deviceWidth:0,//设备宽度
}

const mutations = {
  setIsPc(state,data){
    state.isPC = data
  },
  setActivePath(state,data){
    state.activePath = data
  },
  setDeviceWidth(state,data){
    state.deviceWidth = data
  }
}

const actions = {
  
}

const getters = {
  
}

export default {
  state,
  mutations,
  actions,
  getters
}